<template>
	<div class="constellation-panel">
		<div class="constellation-circle" :style="'transition-duration: '+cTime+'ms; transition-property: transform; transform: rotate('+cDeg+'deg)'"></div>
		<div class="constellation-info"><span>{{cData.cText ? cData.cText : '金牛座'}}</span></div>
	</div>
</template>

<script>
	export default {
		computed: {
			inputData() {
				return this.$store.state.user.inputData;
			}
		},
		data() {
			return {
				cData: {}, cDeg: -30, cTime: 100,
				animationData: {}
			}
		},
		mounted() {
			this.$bus.on('updateConstellation', this.updateConstellation);
		},
		destroyed() {
			this.$bus.off('updateConstellation', this.updateConstellation);
		},
		methods: {
			updateConstellation(cData) {
				if(cData.cText == this.cData.cText) { return; }
				// 添加星座的动画
				var cIndex = cData.index, 
					tempI = this.cData.index ? Math.abs(cData.index-this.cData.index+1) : cData.index,
					cDeg = -cIndex*30, cTime = tempI*100;
				// console.error('updateConstellation-----', cData, tempI, cDeg, cTime)
				this.cData = Object.assign({}, cData);
				this.cDeg = cDeg; this.cTime = cTime == 0 ? 800 : cTime;
			}
		}
	}
</script>

<style>
	.constellation-panel {
		width: 100%;
		margin-top: 25px;
	}
	.constellation-circle {
		width: 280px;
		height: 280px;
		background-image: url('http://m1.2048.net/duoniu/images_thj/index/index-c-bg.png');
		background-size: 100% 100%;
		background-repeat: no-repeat;
		margin: 0 auto;
	}
	.constellation-info {
		position: absolute;
		top: 4rem;
		left: 50%;
		margin-left: -1rem;
		
		width: 2rem;
		height: 1.25rem;
		text-align: center;
		line-height: 1.25rem;
		font-size: 0.425rem;
		color: #DE1D1C;
		white-space: nowrap;
		word-break: keep-all;
		
		
		background: url('http://m1.2048.net/duoniu/images_thj/index/index-c-title.png');
		background-size: 100% auto;
		background-repeat: no-repeat;
	}
</style>